import { Component, OnInit, ViewChild } from '@angular/core';
import { StreamService } from 'src/app/services/stream.service';
import { MatTableDataSource } from '@angular/material';
import {MatSort} from '@angular/material/sort';
import { iHttpPaginatedResponse } from 'src/app/interfaces/iHttpPaginatedResponse';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { FilterOption } from 'src/app/models/filter-option';

@Component({
  selector: 'app-streams',
  templateUrl: './streams.component.html',
  styleUrls: ['./streams.component.scss']
})
export class StreamsComponent implements OnInit {
  public paginatedStreams = new BehaviorSubject<any>(null);
  public loadedStreams: boolean = false;
  public availableFilters=[];
  private filterString='filter[deleted]=&filter[published]';
  public sorts='-created_at';
  public page:number=1;
  public perPage:number=20;
  constructor(private streamService: StreamService) {
    this.availableFilters.push(new FilterOption({name:'name',type:'string'}));
    this.availableFilters.push(new FilterOption({
      name:'published',
      type:'select',
      'options':[
        {name:'Any',value:''},
        {name:'Yes',value:1},
        {name:'No', value:0}
      ],
      default: ''
    }));
    this.availableFilters.push(new FilterOption({
      name:'deleted',
      type:'select',
      'options':[
        {name:'Any',value:''},
        {name:'Yes',value:1},
        {name:'No', value:0}
      ],
      default: 0
    }));
  }

  getStreams(page, perPage){
    this.streamService.getStreams(page,perPage,this.sorts,this.filterString).subscribe(paginatedData=>{
      this.paginatedStreams.next(paginatedData);
      this.loadedStreams = true;
    })
  }

  ngOnInit() {
    this.getStreams(this.page, this.perPage);
  }

  sortChanged(data){
    this.sorts=data;
    this.getStreams(1, this.perPage);
  }

  filterChanged(filters){
    this.filterString = filters;
    this.getStreams(1, this.perPage);
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getStreams(data.pageIndex+1, this.perPage);
  }

  perPageChanged(data){

  }

}
